import { Shop, ShopsDetails } from "./Shops";

export interface UserDetails {
  _id?: string;
  password?: string;
  email?: string;
  verifiedStatus?: string;
  userType?:string;
  name?: string;
  role?: string;
  medium?: string;
  primaryPhone?: string;
  gender?: string;
  premiumStatus?: string;
  googleId?: string;
  facebookId?: string;
  isFirstTime?: string;
  sharedWith?: string[];
  otpCode?: string;
  currency?: string;
  deviceInfo?: string;
  chapterCount?:number;
  createdAt?: string;
  phoneNumber?: string;
  shops?: string[];
  isWebAccess?: boolean;
  shopId?:string;
  branchId?: string;
  branchName?: string;
  // currencyPopulated?: currency;
  hasFullPrivileges?:boolean;
  // userPrivileges?: UserPrivileges;
  shopFields?:string[];
  premiumUserType?: string;
  mainShopOwnerId?: string;
  populatedShop?: Shop;
}

export enum VerifyStatus {
  BLOCKED = "BLOCKED",
  VERIFIED = "VERIFIED",
}

export enum UserType {
  REAL = "REAL",
  TEST = "TEST",
}

export enum PremiumStatus {
  ACTIVE = "ACTIVE",
  TRIAL = "TRIAL",
  REVOKED = "REVOKED",
  NOT_SET = "NOT_SET",
}
